import React, { useMemo } from "react";
import { useController } from "react-hook-form";
import { FormLabel, GridLegacy, MenuItem, Select } from "@mui/material";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import AuthenticationWrapper from "../../../../auth/AuthenticationWrapper";

const options = [
  { label: "Takeaway", value: "takeaway" },
  { label: "Delivery", value: "delivery" },
];

function TakeawayDeliverySetting(props) {
  const {
    field: { value: takeawayValue, onChange: takeawayOnChange },
  } = useController({ name: "delivery_settings__takeAway" });
  const {
    field: { value: deliveryValue, onChange: deliveryOnChange },
  } = useController({ name: "delivery_settings__delivery" });

  const fieldValue = useMemo(() => {
    if (takeawayValue && !deliveryValue) {
      return "takeaway";
    } else if (!takeawayValue && deliveryValue) {
      return "delivery";
    } else {
      return "";
    }
  }, [takeawayValue, deliveryValue]);

  const tKey = "Takeaway/Delivery";
  return (
    <AuthenticationWrapper
      child={(write) => (
        <GridLegacy
          container
          style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: "8px 0" }}
        >
          <GridLegacy
            item
            sm={4}
            style={{
              paddingRight: 32,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              textAlign: "start",
            }}
            xs={12}
          >
            <FormLabel>
              <TranslationWrapper tDefault={tKey} tKey={tKey} />
            </FormLabel>
          </GridLegacy>
          <GridLegacy
            item
            sm={8}
            style={{ display: "flex", alignItems: "center", paddingRight: 32, flexWrap: "wrap" }}
            xs={12}
          >
            <Select
              disabled={!write || props.disabled}
              onChange={(e) => {
                if (e.target.value === "takeaway") {
                  takeawayOnChange(1);
                  deliveryOnChange(0);
                } else if (e.target.value === "delivery") {
                  takeawayOnChange(0);
                  deliveryOnChange(1);
                }
              }}
              style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
              value={fieldValue}
            >
              {options.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    <TranslationWrapper tDefault={option.label} tKey={"takeaway_delivery_settings." + option.value} />
                  </MenuItem>
                );
              })}
            </Select>
          </GridLegacy>
        </GridLegacy>
      )}
      permissionKey={"takeaway_delivery_settings"}
    />
  );
}

export default TakeawayDeliverySetting;
